import type { VisitDto } from "@repo/data-store";
import { TimelinePanelLayout, TimelineProvider, visitVariant } from "@/shared/timeline";

/** The booked appointment is the timeline when no order set defines its work. */
export function AppointmentTimeline({ visit }: { visit: VisitDto }) {
  if (!visit.start || !visit.end) return null;
  const durationMinutes = (new Date(visit.end).getTime() - new Date(visit.start).getTime()) / 60000;
  if (!Number.isFinite(durationMinutes) || durationMinutes <= 0) return null;

  const title =
    visit.serviceType?.text ??
    visit.serviceType?.display ??
    visit.consultationTypeCode?.text ??
    visit.consultationTypeCode?.display ??
    visit.protocolTitle ??
    (visit.kind === "consultation" ? "Consultation" : "Appointment");

  return (
    <TimelineProvider
      density="compact"
      startsAt={visit.start}
      envelopeMinutes={durationMinutes}
      steps={[
        {
          id: visit.visitId,
          startMinutes: 0,
          costMinutes: durationMinutes,
          procedures: [
            {
              id: visit.visitId,
              title,
              variant: visitVariant(visit.status),
              detail: visit.practitionerName,
            },
          ],
        },
      ]}
    >
      <TimelinePanelLayout summary={`${durationMinutes} min booked`} />
    </TimelineProvider>
  );
}
